import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/abandoned-carts")({
  head: () => ({ meta: [{ title: "Abandoned Carts | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-abandoned-carts")),
});
